module.exports = __webpack_public_path__ + "static/img/coupon-player-check.0feab568.png";